module.exports = __webpack_public_path__ + "img/pentagon.ab8426d3.svg";